import { render, staticRenderFns } from "./LoadingSpinnerV2.vue?vue&type=template&id=52d2e4f0&scoped=true"
import script from "./LoadingSpinnerV2.vue?vue&type=script&lang=js"
export * from "./LoadingSpinnerV2.vue?vue&type=script&lang=js"
import style0 from "./LoadingSpinnerV2.vue?vue&type=style&index=0&id=52d2e4f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d2e4f0",
  null
  
)

export default component.exports